<template>
  <b-modal
      :visible="visible"
      title="Fusionner les clients"
      size="lg"
      :no-close-on-backdrop="busy"
      :no-close-on-esc="busy"
      :hide-header-close="busy"
      @hide="onHide"
      @hidden="reset"
  >
    <p>Choisissez le client à conserver. Ses informations seront conservées et les autres clients seront archivés après le transfert de leurs dossiers.</p>
    <b-form-group label="Client à conserver" label-for="merge-target">
      <v-select
          v-model="targetId"
          :options="clients"
          :reduce="client => client.uid"
          :clearable="false"
          :disabled="busy"
          label="name"
          input-id="merge-target"
          placeholder="Choisir le client à conserver"
          @input="confirmed = false"
      >
        <template #option="client">{{ client.name }} — #{{ client.uid }}</template>
        <template #selected-option="client">{{ client.name }} — #{{ client.uid }}</template>
      </v-select>
    </b-form-group>
    <b-table :items="clients" :fields="fields" small responsive>
      <template #cell(name)="data">{{ data.item.name }} (#{{ data.item.uid }})</template>
      <template #cell(email)="data">{{ detail(data.item, 'email') }}</template>
      <template #cell(phone)="data">{{ detail(data.item, 'phone') }}</template>
      <template #cell(address)="data">{{ detail(data.item, 'address') }}</template>
      <template #cell(outcome)="data">
        {{ targetId === null ? 'À choisir' : data.item.uid === targetId ? 'Conservé' : 'Archivé' }}
      </template>
    </b-table>
    <p class="text-muted">Les nombres d’offres et de projets proviennent de la liste des clients. La fusion doit également transférer les factures et préserver les paiements associés.</p>
    <b-form-checkbox v-model="confirmed" :disabled="busy || targetId === null">
      Je confirme la fusion des clients sélectionnés vers le client choisi.
    </b-form-checkbox>
    <b-alert :show="!!error" variant="danger" class="mt-1">{{ error }}</b-alert>
    <template #modal-footer>
      <b-button :disabled="busy" variant="outline-secondary" @click="$emit('close')">Annuler</b-button>
      <b-button :disabled="!canSubmit || busy" variant="danger" @click="merge">
        <b-spinner v-if="busy" small />
        Confirmer la fusion
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import {BModal, BFormGroup, BFormCheckbox, BTable, BAlert, BButton, BSpinner} from 'bootstrap-vue';
import vSelect from 'vue-select';

export default {
  components: {BModal, BFormGroup, BFormCheckbox, BTable, BAlert, BButton, BSpinner, vSelect},
  props: {
    visible: {type: Boolean, default: false},
    clients: {type: Array, required: true},
  },
  data() {
    return {
      targetId: null,
      confirmed: false,
      busy: false,
      error: '',
      fields: [
        {key: 'name', label: 'Client'},
        {key: 'email', label: 'Email'},
        {key: 'phone', label: 'Téléphone'},
        {key: 'address', label: 'Adresse'},
        {key: 'bids_count', label: 'Offres'},
        {key: 'projects_count', label: 'Projets'},
        {key: 'outcome', label: 'Résultat'},
      ],
    };
  },
  computed: {
    canSubmit() {
      return this.$can('merge_customer', 'Clients') && this.confirmed && this.clients.length >= 2
        && this.clients.some(client => client.uid === this.targetId);
    },
  },
  methods: {
    detail(client, key) { return (client.details && client.details[key]) || '—'; },
    onHide(event) {
      if (this.busy) event.preventDefault();
      else this.$emit('close');
    },
    reset() {
      this.targetId = null;
      this.confirmed = false;
      this.error = '';
    },
    async merge() {
      if (!this.canSubmit || this.busy) return;
      this.busy = true;
      this.error = '';
      try {
        await this.$store.dispatch('client/mergeClients', {
          target_customer_id: this.targetId,
          source_customer_ids: this.clients.filter(client => client.uid !== this.targetId).map(client => client.uid),
        });
        this.$emit('merged');
      } catch (error) {
        this.error = error.response && error.response.data && error.response.data.message
          || 'La fusion a échoué. Vérifiez la liste des clients avant de réessayer.';
      } finally {
        this.busy = false;
      }
    },
  },
};
</script>
